import { render, staticRenderFns } from "./AccessControlCard.vue?vue&type=template&id=a70b785e&scoped=true"
import script from "./AccessControlCard.vue?vue&type=script&lang=js"
export * from "./AccessControlCard.vue?vue&type=script&lang=js"
import style0 from "./AccessControlCard.vue?vue&type=style&index=0&id=a70b785e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70b785e",
  null
  
)

export default component.exports